export default __webpack_public_path__ + "static/media/contact-us.b6a3d95a.jpg";